__turbopack_context__.v({
  "card": "sCqmga_card",
  "content": "sCqmga_content",
  "duration": "sCqmga_duration",
  "meta": "sCqmga_meta",
  "thumbnail": "sCqmga_thumbnail",
  "thumbnailImage": "sCqmga_thumbnailImage",
  "title": "sCqmga_title",
  "topic": "sCqmga_topic",
});
